"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBMIT_TRANSACTION = exports.GET_TRANSACTION = exports.GET_RELAY_PAYLOAD = exports.GET_NONCE = exports.GET_ADDRESS = void 0;
exports.GET_ADDRESS = "/address";
exports.GET_NONCE = "/nonce";
exports.GET_RELAY_PAYLOAD = "/relay-payload";
exports.GET_TRANSACTION = "/transaction";
exports.SUBMIT_TRANSACTION = "/submit";
